import { SessionsSchema } from "mock/schemas"

type SessionsSchemaArray = [string, string, string, number, number, "OVER" | "IN_PROGRESS", string, string, string, string]

const sessionsArray: SessionsSchemaArray[] = [
    ["1", "2024-08-21T17:58:47", "2024-08-21T18:41:02", 9, 10, "OVER", "1", "1", "1", "1"],
    ["2", "2023-06-13T10:09:10", "2023-06-13T11:29:02", 11, 16, "OVER", "6", "2", "2", "1"],
    ["3", "2024-02-20T09:41:05", "2024-02-20T11:31:58", 18, 13, "OVER", "4", "10", "10", "1"],
    ["4", "2023-07-24T21:29:07", "2023-07-24T23:12:51", 17, 7, "OVER", "1", "10", "10", "1"],
    ["5", "2024-05-03T05:26:45", "2024-05-03T05:56:27", 7, 17, "OVER", "5", "13", "13", "1"],
    ["6", "2023-08-21T17:58:47", "2023-08-21T18:41:02", 9, 10, "OVER", "1", "1", "1", "1"],
    ["7", "2023-06-14T10:09:10", "2023-06-14T11:29:02", 11, 16, "OVER", "6", "2", "2", "1"],
    ["8", "2024-02-20T09:41:05", "", 18, 13, "IN_PROGRESS", "4", "10", "10", "1"],
    ["9", "2023-07-24T21:29:07", "2023-07-24T23:12:51", 17, 7, "OVER", "1", "10", "10", "1"],
    ["10", "2023-05-04T05:26:45", "2023-05-04T05:56:27", 7, 17, "OVER", "5", "13", "13", "1"],
    ["11", "2024-05-03T05:26:45", "", 7, 17, "IN_PROGRESS", "5", "13", "13", "1"],
    ["12", "2024-01-10T06:20:56", "2024-01-10T07:34:24", 15, 13, "OVER", "5", "17", "17", "2"],
    ["13", "2023-06-05T23:08:16", "2023-06-06T00:49:39", 13, 6, "OVER", "5", "19", "19", "2"],
    ["14", "2023-04-06T02:39:57", "2023-04-06T03:58:38", 17, 5, "OVER", "1", "45", "15", "2"],
    ["15", "2024-01-30T04:32:48", "", 9, 11, "IN_PROGRESS", "2", "36", "16", "2"],
    ["16", "2023-10-26T16:45:08", "2023-10-26T18:05:06", 6, 6, "OVER", "2", "20", "20", "2"],
    ["17", "2023-08-21T17:58:47", "2023-08-21T18:41:02", 9, 10, "OVER", "1", "1", "1", "1"],
    ["18", "2023-06-13T10:09:10", "2023-06-13T11:29:02", 11, 16, "OVER", "6", "2", "2", "1"],
    ["19", "2024-02-20T09:41:05", "2024-02-20T11:31:58", 18, 13, "OVER", "4", "10", "10", "1"],
    ["20", "2023-07-24T21:29:07", "2023-07-24T23:12:51", 17, 7, "OVER", "1", "10", "10", "1"],
    ["21", "2023-05-18T05:26:45", "2024-05-18T05:56:27", 7, 17, "OVER", "5", "13", "13", "1"],
    ["22", "2023-08-21T17:58:47", "2023-08-21T18:41:02", 9, 10, "OVER", "1", "1", "1", "1"],
    ["23", "2023-06-17T10:09:10", "2023-06-17T11:29:02", 11, 16, "OVER", "6", "2", "2", "1"],
    ["24", "2024-02-20T09:41:05", "", 18, 13, "IN_PROGRESS", "4", "10", "10", "1"],
    ["25", "2023-07-24T21:29:07", "2023-07-24T23:12:51", 17, 7, "OVER", "1", "10", "10", "1"],
    ["26", "2023-05-03T05:26:45", "2023-05-03T05:56:27", 7, 17, "OVER", "5", "13", "13", "1"],
    ["27", "2023-05-01T05:26:45", "", 7, 17, "IN_PROGRESS", "5", "13", "13", "1"],
    ["28", "2024-01-10T06:20:56", "2024-01-10T07:34:24", 15, 13, "OVER", "5", "17", "17", "2"],
    ["29", "2023-06-11T23:08:16", "2023-06-12T00:49:39", 13, 6, "OVER", "5", "19", "19", "2"],
    ["30", "2023-04-06T02:39:57", "2023-04-06T03:58:38", 17, 5, "OVER", "1", "45", "15", "2"],
    ["31", "2024-01-30T04:32:48", "", 9, 11, "IN_PROGRESS", "2", "36", "16", "2"],
    ["32", "2023-10-26T16:45:08", "2023-10-26T18:05:06", 6, 6, "OVER", "2", "20", "20", "2"],
    ["33", "2023-08-21T17:58:47", "2023-08-21T18:41:02", 9, 10, "OVER", "1", "1", "1", "1"],
    ["34", "2023-06-13T10:09:10", "2023-06-13T11:29:02", 11, 16, "OVER", "6", "2", "2", "1"],
    ["35", "2024-02-29T09:41:05", "2024-02-29T11:31:58", 18, 13, "OVER", "4", "10", "10", "1"],
    ["36", "2023-07-27T21:29:07", "2023-07-27T23:12:51", 17, 7, "OVER", "1", "10", "10", "1"],
    ["37", "2024-03-03T05:26:45", "2024-03-03T05:56:27", 7, 17, "OVER", "5", "13", "13", "1"],
    ["38", "2023-08-21T17:58:47", "2023-08-21T18:41:02", 9, 10, "OVER", "1", "1", "1", "1"],
    ["39", "2023-06-13T10:09:10", "2023-06-13T11:29:02", 11, 16, "OVER", "6", "2", "2", "1"],
    ["40", "2024-03-20T09:41:05", "", 18, 13, "IN_PROGRESS", "4", "10", "10", "1"],
    ["41", "2023-07-24T21:29:07", "2023-07-24T23:12:51", 17, 7, "OVER", "1", "10", "10", "1"],
    ["42", "2023-05-03T05:26:45", "2023-05-03T05:56:27", 7, 17, "OVER", "5", "13", "13", "1"],
    ["43", "2024-03-03T05:26:45", "", 7, 17, "IN_PROGRESS", "5", "13", "13", "1"],
    ["44", "2024-03-10T06:20:56", "2024-03-10T07:34:24", 15, 13, "OVER", "5", "17", "17", "2"],
    ["45", "2023-08-11T23:08:16", "2023-08-12T00:49:39", 13, 6, "OVER", "5", "19", "19", "2"],
    ["46", "2023-04-06T02:39:57", "2023-04-06T03:58:38", 17, 5, "OVER", "1", "45", "15", "2"],
    ["47", "2024-03-30T04:32:48", "", 9, 11, "IN_PROGRESS", "2", "36", "16", "2"],
    ["48", "2024-03-26T16:45:08", "2024-03-26T18:05:06", 6, 6, "OVER", "2", "20", "20", "2"],

]

const createSessionObject = (arr: SessionsSchemaArray): SessionsSchema => {
    return {
        id: arr[0],
        start: arr[1],
        end: arr[2],
        price: arr[3],
        kwh: arr[4],
        status: arr[5],
        station_id: arr[6],
        rfid_id: arr[7],
        driver_id: arr[8],
        entity_id: arr[9],
    }
}

export const sessionsMockDatas: SessionsSchema[] = sessionsArray.map((arr) =>
    createSessionObject(arr)
)
